export default __webpack_public_path__ + "static/media/1_en.551c94ca.png";